import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { DEFAULT_POPUP_CONFIG, DroplistItem, DroplistWidget } from '@eforall/dashboard';
import { AcceleratorAreaService } from './accelerator-area.service';
import { Router } from '@angular/router';

@Component({
	selector: 'accelerator-droplist',
	standalone: true,
	templateUrl: './accelerator-droplist.widget.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [DroplistWidget]
})
export class AcceleratorDroplistWidget {

	public readonly popupConfig = DEFAULT_POPUP_CONFIG;
	private readonly service = inject(AcceleratorAreaService);
	private readonly router = inject(Router);

	public items = computed<DroplistItem<string, number>[]>(() => {

		const data = this.service.data();
		if (!data) return [];

		return data.accs.map(a => {
			return {
				uniqueId: a.accId,
				data: a.name,
				iconContext: {
					iconClass: 'fa-gauge-high',
					iconStyle: 'fa-regular',
					text: a.detailedName,
					hideText: 'never',
				},
			};
		});
	});


	public selectedItem = computed<DroplistItem<string, number> | undefined>(() => {

		const items = this.items();
		if (items.length == 0) return undefined;

		const data = this.service.data();
		if (!data) return undefined;

		return items.find(i => i.uniqueId == data.acc.accId);
	});


	public onSelection(item: DroplistItem | undefined) {
		
		const path = location.pathname;
		const pathParts = path.split('/');
		pathParts[pathParts.length - 2] = item?.data;
		const newPath = pathParts.join('/');
		
		this.router.navigateByUrl(newPath);
		
	}

}